import {type ScheduleItem} from '@domain/schedule'
import {dataTestId, formatTimeZoneDate} from '@hconnect/uikit'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {PLANNING_SCHEDULE_CHART_WIDGET_NAMESPACE} from '../../../consts'

interface OperationTimeStartEndRowProps {
  scheduleItem: ScheduleItem
}

export const OperationTimeStartEndRow = ({scheduleItem}: OperationTimeStartEndRowProps) => {
  const {
    t,
    i18n: {language}
  } = useTranslation(PLANNING_SCHEDULE_CHART_WIDGET_NAMESPACE)
  const timezoneId = useUpmPlantTimezone()
  return (
    <Stack spacing={2} direction="row">
      <Stack {...dataTestId('operation_start_time')} sx={{flex: '50%'}}>
        <Typography variant="caption">{t('common.start')}</Typography>
        <Typography variant="body1">
          {formatTimeZoneDate(scheduleItem.start, timezoneId, 'ddd DD, HH:mm', language)}
        </Typography>
      </Stack>
      <Stack {...dataTestId('operation_end_time')} sx={{flex: '50%'}}>
        <Typography variant="caption">{t('common.end')}</Typography>
        <Typography variant="body1">
          {formatTimeZoneDate(scheduleItem.end, timezoneId, 'ddd DD, HH:mm', language)}
        </Typography>
      </Stack>
    </Stack>
  )
}
